<template src="./usersPreliminaryModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import usersEndpoints from '../users.endpoints.js';

export default {
    name: 'users-preliminary-modal',
    mixins: [dmModalMixin],
    data() {
        return {
            autoCompleteValueTimer: null,
            userID: null,
            emailOptions: [],
            emailFields: {
                text: 'Email',
                value: 'UserID',
            },
            selectedUser: null,
            isGardnerUser: false,
            emailOptions: [],
            selectedUser: null,
            userEmail: '',
            disableContinueButton: true,
        };
    },
    computed: {
        lblTitle() {
            return this.selectedUser ? 'Edit User' : `Add ${this.modalData.userType.Text} User`;
        },
    },
    methods: {
        editUser() {
            let modalData = {
                    mode: 'edit',
                    dto: {},
                    callback: this.modalData.callback,
                };

            usersEndpoints.getByID(this.selectedUser.UserID, this.modalData.userType.Value)
                .then((response) => {
                    modalData.dto = response;
                    modalData.dto.UserType = this.modalData.userType;

                    this.closePreliminaryModal()
                        .then(() => {
                            DMUtils.openApplicationModal('usersEditModal', modalData);
                        });
                });
        },
        addNewUser() {
            let modalData = {
                mode: 'add',
                dto: {
                    Email: this.userEmail,
                    FirstName: '',
                    LastName: '',
                    IsActive: true,
                    UserType: this.modalData.userType,
                    EntityRoles: [],
                },
                callback: this.modalData.callback,
            };

            this.closePreliminaryModal()
                .then(() => {
                    DMUtils.openApplicationModal('usersEditModal', modalData);
                });
        },
        btnContinueOnClick() {
            if (this.selectedUser) {
                this.editUser();
            } else {
                if (this.emailOptions.length > 0) {
                    this.emailOptions.forEach((email) => {
                        if (email.Email === this.userEmail) {
                            this.selectedUser = email;
                        }
                    });        
                }

                if (this.selectedUser) {
                    this.editUser();
                } else {
                    this.addNewUser();
                }
            }
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        selectExistingUser(args) {
            this.selectedUser = args.itemData;
        },
        autoCompleteUsersName(e) {
            e.preventDefaultAction = true;
            this.userEmail = e.text;
            this.selectedUser = null;
            this.disableContinueButton = true;

            if (this.autoCompleteValueTimer) {
                clearTimeout(this.autoCompleteValueTimer);
            }

            this.autoCompleteValueTimer = setTimeout(() => {
                this.emailOptions = [];

                usersEndpoints.autoComplete(e.text)
                    .then((response) => {
                        if (response.length > 0) {
                            this.emailOptions = response;
                            this.$refs.usersAutocomplete.showPopup();
                        }

                        this.emailOptions.forEach((option) => {
                            if (option.Email === e.text) {
                                this.selectedUser = option;
                            }
                        });

                    this.disableContinueButton = false;
                });                
            }, 1000);
        },
        closePreliminaryModal() {
            return new Promise((resolve) => {
                this.$store.commit('ModalModule/closeModal', this.modalID);
                return resolve();
            });
        },
    },
};
</script>
